import React from "react";
import { useState } from "react";
import AcquisEvalBilan from "../VueEvalNat/BilanEval/AcquisEvalBilan";
function SelectEvalBilan({EvalNat, listEvals}) {
const [selectedEval, setSelectedEval] = useState();


const handleSelectEval = (e) => {
    const evalId = e.target.value;
const evalObject = listEvals.find(evaluation => evaluation.id.toString() === evalId);

// Mettre à jour selectedEval comme un tableau contenant uniquement l'objet évaluation trouvé
setSelectedEval([evalObject]); // Utiliser un tableau avec un seul élément

}
  // Gère le rechargement des données lorsque EvalsNat ou reload change


    return (
     
        <div>
         <><p className=" text-lg font-bold ">  Sélectionner l'évaluation standardisé :  </p> 
        <select value={selectedEval ? selectedEval.id : ""} onChange={handleSelectEval} className="border border-gray-500 rounded-md p-2 text-base font-bold">
          <option value=""> Choisir l'évaluation</option>
                  {listEvals && listEvals.map( (item) => 
                       <option key={item.id} value={item.id}>{item.titre} </option>
                  )}
   
      </select>

      </> 

      {(selectedEval && selectedEval[0] && selectedEval[0].titre !== "Evaluation Nationale")  &&
           <AcquisEvalBilan EvalNat={EvalNat[0]} evalBilan={selectedEval[0]} classe={selectedEval[0].classe_nom}/> }
           

      </div>

    )
}

export default SelectEvalBilan;